import { render, staticRenderFns } from "./CreateCommentModal1.vue?vue&type=template&id=3b0ac154&scoped=true"
import script from "./CreateCommentModal1.vue?vue&type=script&lang=js"
export * from "./CreateCommentModal1.vue?vue&type=script&lang=js"
import style0 from "./CreateCommentModal1.vue?vue&type=style&index=0&id=3b0ac154&prod&lang=css"
import style1 from "./CreateCommentModal1.vue?vue&type=style&index=1&id=3b0ac154&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0ac154",
  null
  
)

export default component.exports